const formattedAmount = (amount) => {
  return parseFloat(amount).toFixed(2);
};

const TaxData = ({ data }) => {
  const item = data.find((d) => d.sales_price); // Find the object with sales_price
  const mrpItem = data.find((d) => d.mrp_price); // Find the object with mrp_price
  return (
    <div className=" border my-3 bg-white">
      {/* <h2 className="text-md font-semibold mb-2">Tax Breakdown</h2>
      <p>MRP Price: {mrpItem?.mrp_price || "N/A"}</p>
      <p>Sale Price: {item?.sales_price || "N/A"}</p> */}

      {item && (
        <table className="min-w-full bg-white border border-gray-200">
          <thead>
            <tr className="bg-gray-100 border-b">
              <th className="px-4 py-2 text-left text-gray600 font-semibold">
                Tax Name
              </th>
              <th className="px-4 py-2 text-left text-gray600 font-semibold">
                Tax Rate
              </th>
              <th className="px-4 py-2 text-gray600 font-semibold text-right">
                Amount
              </th>
            </tr>
          </thead>
          <tbody>
            <tr className="border-b">
              <td className="px-4 py-2 text-gray-700">Product Base Price</td>
              <td></td>
              <td className="px-4 py-2 text-gray-700 text-right">
                {formattedAmount(item.sales_price)}
              </td>
            </tr>

            {item.taxData?.standardTax?.map((tax, index) => (
              <tr key={index} className="border-b">
                <td className="px-4 py-2 text-gray-700">{tax.name}</td>
                <td className="px-4 py-2 text-gray-700">{tax.rate}%</td>
                <td className="px-4 py-2 text-gray-700 text-right">
                  {formattedAmount(tax.taxAmount)}
                </td>
              </tr>
            ))}

            <tr className="border-b">
              <td className="px-4 py-2 text-gray-600">Line Rebase</td>
              <td></td>
              <td className="px-4 py-2 text-gray-700 text-right">
                {formattedAmount(item.taxData?.rebase)}
              </td>
            </tr>

            <tr className="border-b">
              <td className="px-4 py-2 text-gray-600">Referral Fee</td>
              <td className="px-4 py-2 text-gray-700">
                {item.taxData?.referralFee?.percentage}%
              </td>
              <td className="px-4 py-2 text-gray-700 text-right">
                {formattedAmount(item.taxData?.referralFee?.amount)}
              </td>
            </tr>

            <tr className="border-b">
              <td className="px-4 py-2 text-gray-600">Closing Fee</td>
              <td></td>
              <td className="px-4 py-2 text-gray-700 text-right">
                {formattedAmount(item.taxData?.closingFee)}
              </td>
            </tr>

            <tr className="border-b">
              <td className="px-4 py-2 text-gray-600">Additional Fee</td>
              <td></td>
              <td className="px-4 py-2 text-gray-700 text-right">
                {formattedAmount(item.taxData?.additionalFee)}
              </td>
            </tr>

            <tr className="border-b">
              <td className="px-4 py-2 text-gray-600">Taxable Amount</td>
              <td></td>
              <td className="px-4 py-2 text-gray-700 text-right">
                {formattedAmount(item.taxData?.taxableAmount)}
              </td>
            </tr>

            {item.taxData?.vat?.map((vat, index) => (
              <tr key={index} className="border-b">
                <td className="px-4 py-2 text-gray-700">{vat.name}</td>
                <td className="px-4 py-2 text-gray-700">{vat.rate}%</td>
                <td className="px-4 py-2 text-gray-700 text-right">
                  {formattedAmount(vat.taxAmount)}
                </td>
              </tr>
            ))}

            <tr className="border-b">
              <td className="px-4 py-2 text-gray-600">Grand Total</td>
              <td></td>
              <td className="px-4 py-2 text-gray-700 text-right">
                {formattedAmount(item.taxData?.grandTotal)}
              </td>
            </tr>
          </tbody>
        </table>
      )}
    </div>
  );
};

export default TaxData;
